import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ParkingQuoteResult } from '@sabstravtech/obtservices/base';

import { LightningModalTypes } from '../../core/classes/modal-types.enum';

@Component({
  selector: 'app-gmt-parking-fare-rules-modal',
  templateUrl: './gmt-parking-fare-rules-modal.html',
  styleUrls: ['./gmt-parking-fare-rules-modal.scss'],
  standalone: false
})
export class GmtParkingModalFareRulesComponent implements OnInit {
  parking: ParkingQuoteResult = null;
  canOverride = false;
  constructor(public modal: NgbActiveModal) {}

  ngOnInit(): void {}
}

LightningModalTypes.GmtParkingModalFareRulesComponent.component = GmtParkingModalFareRulesComponent;
